import Splitter from '@datacloud-incubation/frontend-splitter-module';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router';
import ComponentErrorFallback from '@components/ComponentErrorFallback/ComponentErrorFallback';
import Header from '@components/Layout/components/Header/Header';
import { SplitterId } from '@constants/common.constant';
import FeaturesList from './components/FeaturesList/FeaturesList';
import { LAYOUT_MODE } from './constants/layout.constant';
import type { TLayoutProps } from './models/layout.model';
import type { FC } from 'react';
import styles from './Layout.module.css';

const Layout: FC<TLayoutProps> = ({ layoutMode }) => {
  const layout = {
    [LAYOUT_MODE.public]: (
      <ErrorBoundary FallbackComponent={ComponentErrorFallback}>
        <Outlet />
      </ErrorBoundary>
    ),
    [LAYOUT_MODE.protected]: (
      <div className={styles.layout}>
        <section className={styles.header}>
          <Header />
        </section>
        <section className={styles.body}>
          <main className={styles.content}>
            <Splitter
              id={SplitterId.AppLayout}
              leftPanel={{
                content: <FeaturesList />,
                minSize: 12,
                defaultSize: 20
              }}
              rightPanel={{
                content: (
                  <div className={styles.rightContent}>
                    <ErrorBoundary FallbackComponent={ComponentErrorFallback}>
                      <Outlet />
                    </ErrorBoundary>
                  </div>
                ),
                minSize: 50
              }}
            />
          </main>
        </section>
      </div>
    )
  } as const;

  return layout[layoutMode];
};

export default Layout;
